import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
import store from "@/store/index";
import GeneralUtilsHelper from "@/utils/generalUtils";
let greenLightEnable: boolean = false; //默认不支持
const Getters: GetterTree<any, any> = {
  [types.GETTER_CURRENT_FEED](state, getters, rootState) {
    if (state.feeds.length === 0) {
      return null;
    } else {
      return state.feeds[0];
    }
  },
  [types.GETTER_EARN_COIN_FEED](state, getters, rootState) {
    return state.feeds;
  },
  [types.GETTER_EARN_COINS_GREEN_LIGHT](state, getters, rootState) {
    //判断是否支持earn coins的权重参数：
    return () => {
      if (greenLightEnable) {
        return true;
      }
      const { feed_coin_offers } = store.getters[types.GETTER_SETTING_DATA];
      if (
        feed_coin_offers[0] &&
        feed_coin_offers[0].hasOwnProperty("green_light") &&
        feed_coin_offers[0].green_light.hasOwnProperty("weight") &&
        feed_coin_offers[0].green_light.hasOwnProperty("retry_weight")
      ) {
        greenLightEnable = true;
        return true;
      } else {
        greenLightEnable = false;
        return false;
      }
    };
  },
  [types.GETTER_RANDOM_FEED_OFFER](state, getters, rootState) {
    return () => {
      let { feed_coin_offers } = store.getters[types.GETTER_SETTING_DATA];
      const randomArr = [];
      let totalWeight = 0;
      //如果用户是vip过滤掉：
      //判断是否是vip
      // console.log("GeneralUtilsHelper.isVip():", GeneralUtilsHelper.isVip());
      if (GeneralUtilsHelper.isVip()) {
        feed_coin_offers = feed_coin_offers.filter((offer: any) => {
          return !(offer.kind.indexOf("vip") > -1);
        });
      }

      //过滤掉super pay的:feed_super_pay
      if (!getters[types.GETTER_SUPER_PAY_SHOW_ENABLE]) {
        console.log("发现不能插入supepay的feed");
        feed_coin_offers = feed_coin_offers.filter((offer: any) => {
          return !(offer.kind === "feed_super_pay");
        });
      }

      //过滤掉back up的:
      if (!getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE]) {
        console.log("发现不能插入backup的feed");
        feed_coin_offers = feed_coin_offers.filter((offer: any) => {
          return !(offer.kind === "feed_back_up");
        });
      }

      for (const item of feed_coin_offers) {
        totalWeight += item.green_light.weight;
      }

      for (const offer of feed_coin_offers) {
        const times: any = Math.ceil(
          (offer.green_light.weight / totalWeight) * 100
        );
        for (let i = 0; i < times; i++) {
          randomArr.push({
            kind: "offer",
            sub_kind: "offer",
            offer: {
              ...offer
            },
            feed_id: offer.offer_id,
            coins: 0
          });
        }
      }

      //从0-100选一个随机数:
      const randomNum = Math.floor(Math.random() * 100);

      //如果用户是vip的话
      return randomArr[randomNum];
    };
  },
  [types.GETTER_RETRY_FEED_OFFER](state, getters, rootState) {
    //返回是retry类型的offer,需要加入特别字段，让earn coins组件知道是来自于retry的
    return () => {
      let { feed_coin_offers } = store.getters[types.GETTER_SETTING_DATA];
      const retryRandomArr = [];
      let retryTotalWeight = 0;
      //先让vip和feed coins进来
      feed_coin_offers = feed_coin_offers.filter((offer: any) => {
        return offer.kind === "feed_coin" || offer.kind.indexOf("vip") > -1;
      });

      //如果用户是vip过滤掉：
      if (GeneralUtilsHelper.isVip()) {
        feed_coin_offers = feed_coin_offers.filter((offer: any) => {
          return !(offer.kind.indexOf("vip") > -1);
        });
      }

      for (const item of feed_coin_offers) {
        retryTotalWeight += item.green_light.retry_weight;
      }

      for (const offer of feed_coin_offers) {
        const times: any = Math.ceil(
          (offer.green_light.retry_weight / retryTotalWeight) * 100
        );
        for (let i = 0; i < times; i++) {
          retryRandomArr.push({
            retry_offer: true, //让组件知道
            kind: "offer",
            sub_kind: "offer",
            offer: {
              ...offer
            },
            feed_id: offer.offer_id,
            coins: 0
          });
        }
      }

      //从0-100选一个随机数:
      const randomNum = Math.floor(Math.random() * 100);
      // console.log(
      //   "GETTER_RETRY_FEED_OFFER retryRandomArr[randomNum];",
      //   retryRandomArr[randomNum]
      // );

      //如果用户是vip的话
      return retryRandomArr[randomNum];
    };
  }
};

export default Getters;
